import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles, useSelector } from '@grandvisionhq/state';
import Modal from '../Modal/Modal.js';
import GuestForm from './components/GuestForm.js';
import UserForm from './components/UserForm.js';

const FORM_NAME = 'backInStockNotificationSignUpForm';
const BackInStockModal = ({ isOpen , onModalClose , onSubmit  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const { featureConfigs: { backInStockNotificationPeriodDays  } ,  } = useFeatureToggles();
    const { email: userEmail  } = useSelector(Selectors.getAuth);
    const labels = {
        consentMessage: getFormattedLabel('backInStock.signUpModal.consentMessage', {
            parseLink: true
        }),
        consentMessageWithEmail: getFormattedLabel('backInStock.signUpModal.consentMessageWithPrefilledEmail', {
            parseLink: true,
            labelData: {
                email: `${userEmail}`
            }
        }),
        cta: getLabel('backInStock.signUpModal.cta'),
        description: getFormattedLabel('backInStock.signUpModal.description', {
            labelData: {
                count: backInStockNotificationPeriodDays
            }
        }),
        title: getLabel('backInStock.signUpModal.title'),
        inputRequired: getLabel('common.form.field.requiredError'),
        emailLabel: getLabel('fields.input.email.label'),
        emailError: getLabel('fields.input.email.errorMessage')
    };
    const handleSubmit = (email)=>{
        onSubmit(email);
        onModalClose();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: isOpen,
        onModalClose: onModalClose,
        title: labels.title,
        showCloseButton: true,
        children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, labels.description), userEmail ? /*#__PURE__*/ React.createElement(UserForm, {
            labels: {
                consentMessageWithEmail: labels.consentMessageWithEmail,
                consentMessage: labels.consentMessage,
                inputRequired: labels.inputRequired
            },
            formName: FORM_NAME,
            onSubmit: ()=>handleSubmit(userEmail)
        }) : /*#__PURE__*/ React.createElement(GuestForm, {
            labels: {
                consentMessage: labels.consentMessage,
                emailLabel: labels.emailLabel,
                emailError: labels.emailError
            },
            formName: FORM_NAME,
            onSubmit: (email)=>handleSubmit(email)
        })),
        footer: /*#__PURE__*/ React.createElement(Button, {
            caption: labels.cta,
            variant: "solid",
            className: "back-in-stock-modal__footer-button",
            form: FORM_NAME,
            type: "submit"
        })
    });
};

export { BackInStockModal };
//# sourceMappingURL=BackInStockModal.js.map
